export const CONFIG = {
  BASE_URL: process.env.REACT_APP_BASE_API_URL,
  API_TIMEOUT: 10000,
  AUTO_REFETCH_INTERVAL: 30000,
};
